import { render, staticRenderFns } from "./showImage.vue?vue&type=template&id=e14a3b98&scoped=true&"
import script from "./showImage.vue?vue&type=script&lang=js&"
export * from "./showImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14a3b98",
  null
  
)

export default component.exports